import _ from 'lodash'

import {
  ADD_ANNOUNCEMENT_FIELD_ERROR,
  ADD_ANNOUNCEMENT_FIELDS_ERRORS,
  CHANGE_ANNOUNCEMENT_FIELD,
  CLEAR_ANNOUNCEMENT_FIELD_ERROR,
  PREDEFINE_ANNOUNCEMENT_FORM_DATA,
  RESET_ANNOUNCEMENT_FORM_DATA,
} from './actions'

export const defaultFormData = (predefined = {}) =>
  _.merge(
    {
      title: '',
      content: '',
      thumbnail_url: '',
    },
    predefined,
  )

export const initialState = () => ({
  formData: defaultFormData(),
  errors: {},
})

export default function root(state = initialState(), action) {
  switch (action.type) {
    case CHANGE_ANNOUNCEMENT_FIELD:
      return {
        ...state,
        formData: {
          ...state.formData,
          [action.payload.key]: action.payload.value,
        },
      }

    case ADD_ANNOUNCEMENT_FIELD_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.field]: action.payload.error,
        },
      }

    case ADD_ANNOUNCEMENT_FIELDS_ERRORS:
      return {
        ...state,
        errors: action.payload.errors,
      }

    case CLEAR_ANNOUNCEMENT_FIELD_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.field]: undefined,
        },
      }

    case PREDEFINE_ANNOUNCEMENT_FORM_DATA:
      return {
        ...state,
        formData: defaultFormData(action.payload),
        errors: {},
      }

    case RESET_ANNOUNCEMENT_FORM_DATA:
      return {
        ...state,
        formData: defaultFormData(),
        errors: {},
      }

    default:
      return state
  }
}
